import { MasterDocumentsTable } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/components/MasterDocumentsTable/MasterDocumentsTable.tsx';
import { MasterDocumentsScopeProvider } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/MasterDocumentsScopeContext.tsx';
import { StyledSettingsContainer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/styles.ts';

interface Props {
	organizationId: string;
}

export const ProgrammeDefaultsMasterDocuments = ({ organizationId }: Props) => (
	<StyledSettingsContainer>
		<MasterDocumentsScopeProvider organizationId={organizationId}>
			<MasterDocumentsTable />
		</MasterDocumentsScopeProvider>
	</StyledSettingsContainer>
);
